import { useCallback } from "react";

import { ACCOUNT_STATUSES } from "shared/lib/constants/account";
import { modalHelpers } from "shared/lib/helpers/modalHelpers";
import { AccountStatusI } from "shared/lib/interfaces/account";

import { useAccountsContext } from "@/hooks/use-accounts-context";
import { useAccountDetailsContext } from "@/modules/pipeline/account-details/context";
import { ACCOUNT_BOOK_MEETING_MODAL_ID } from "@/modals/account-book-meeting-modal";

/**
 * Opens the existing Modify-meeting flow (book a new slot, cancel the old
 * one) for the account in the drawer. Shared by the status menu and the
 * calendar-event card, which falls back to it when the detected event cannot
 * be moved in place (GLE-8249).
 */
export const useModifyMeeting = () => {
  const { setModalAccount } = useAccountsContext();
  const { campaign, account, accountStatus } = useAccountDetailsContext();

  return useCallback(() => {
    setModalAccount({
      campaignId: campaign?.id || "",
      accountId: account?.id || "",
      accountName: account?.name || "",
      accountStatus: accountStatus?.status as AccountStatusI,
      targetAccountStatus: ACCOUNT_STATUSES.MEETING_SCHEDULED,
      contact: {
        contact_id: accountStatus?.primary_contact_id || "",
        title: accountStatus?.primary_contact_title || "",
        email: accountStatus?.primary_contact_email || "",
        name: accountStatus?.primary_contact_name || "",
      },
      followUpTime: accountStatus?.meeting_time || "",
    });

    modalHelpers.lazyOpen(ACCOUNT_BOOK_MEETING_MODAL_ID);
  }, [campaign, account, accountStatus, setModalAccount]);
};
